import { useTranslation } from 'react-i18next';
import { ArrowRightIcon } from '../../../assets/ArrowRight';
import { Card } from '../../../components/ui/card';
import { Separator } from '../../../components/ui/separator';
import { useTelegramBackButton } from '../../../utils/BackButton';

export const About = () => {
  const { t } = useTranslation();
  useTelegramBackButton('/profile');
  return (
    <div className="flex h-full flex-col overflow-y-auto px-4">
      <div className="flex flex-col space-y-7">
        <p className="text-display-sm text-center">{t('about')}</p>
        <div className="flex flex-col space-y-2">
          <p className="text-caption-sm-medium text-text-secondary pl-4 uppercase">
            {t('low-docs')}
          </p>
          <Card className="flex flex-col rounded-xl pl-4 py-[11px]">
            <div className="flex flex-col space-y-[12px]">
              <div className="flex flex-row items-center justify-between">
                <p className="text-body-base-regular text-text-primary">
                  {t('terms')}
                </p>
                <div className="pr-2">
                  <ArrowRightIcon className="text-text-icon-tertiary" />
                </div>
              </div>
              <Separator className="mt-2" />
              <div className="flex flex-row items-center justify-between">
                <p className="text-body-base-regular text-text-primary">
                  {t('privacy')}
                </p>
                <div className="pr-2">
                  <ArrowRightIcon className="text-text-icon-tertiary" />
                </div>
              </div>
              <Separator className="" />
              <div className="flex flex-row items-center justify-between">
                <p className="text-body-base-regular text-text-primary">
                  {t('public-terms')}
                </p>
                <div className="pr-2">
                  <ArrowRightIcon className="text-text-icon-tertiary" />
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default About;
